module.exports = __webpack_public_path__ + "media/images/breadcrumb/overlay-695a0e1c4bd5c8f37324283e0115c406.png";